import { buildProps } from '@jdesign-vue/utils'
import { panelRangeSharedProps } from './shared'

import type { ExtractPropTypes } from 'vue'

export const panelQuarterRangeProps = buildProps({
  ...panelRangeSharedProps,
} as const)

export const panelQuarterRangeEmits = ['pick', 'set-picker-option']

export type PanelQuarterRangeProps = ExtractPropTypes<
  typeof panelQuarterRangeProps
>
